import { type LoaderFunctionArgs, json } from '@remix-run/node'
import { useLoaderData } from '@remix-run/react'
import { FacultyPhoto } from '#app/components/FacultyPhoto.tsx'
import { getStaffList } from '#app/models/staff.server.js'

export async function loader({ params }: LoaderFunctionArgs) {
	const staffMember = await getStaffList()
	return json({
		person: staffMember.find((person) => person.id === params.facultyID),
	})
}

export default function FacultyIndedRoute() {
	const { person } = useLoaderData<typeof loader>()
	return (
		<main>
			<div className="relative isolate overflow-hidden bg-stone-900">
				<div className="absolute inset-x-0 top-1/2 -z-10 -translate-y-1/2 transform-gpu overflow-hidden opacity-30 blur-3xl">
					<svg
						viewBox="0 0 1313 771"
						aria-hidden="true"
						className="ml-[max(50%,38rem)] w-[82.0625rem]"
					>
						<path
							id="bc169a03-3518-42d4-ab1e-d3eadac65edc"
							fill="url(#85a0eca5-25f1-4ab9-af84-4e2d8d9cdbf3)"
							d="M360.508 589.796 231.671 770.522 0 498.159l360.508 91.637 232.034-325.485c1.485 150.396 51.235 393.965 238.354 165.069C1064.79 143.261 1002.42-107.094 1171.72 46.97c135.44 123.252 148.51 335.641 138.11 426.428L971.677 339.803l24.062 411.461-635.231-161.468Z"
						/>
						<defs>
							<linearGradient
								id="85a0eca5-25f1-4ab9-af84-4e2d8d9cdbf3"
								x1="1313.17"
								x2="-88.881"
								y1=".201"
								y2="539.417"
								gradientUnits="userSpaceOnUse"
							>
								<stop stopColor="#9089FC" />
								<stop offset={1} stopColor="#FF80B5" />
							</linearGradient>
						</defs>
					</svg>
				</div>
				<div className="absolute inset-x-0 top-0 -z-10 flex transform-gpu overflow-hidden pt-32 opacity-25 blur-3xl sm:pt-40 xl:justify-end">
					<svg
						viewBox="0 0 1313 771"
						aria-hidden="true"
						className="ml-[-22rem] w-[82.0625rem] flex-none origin-top-right rotate-[30deg] xl:ml-0 xl:mr-[calc(50%-12rem)]"
					>
						<use href="#bc169a03-3518-42d4-ab1e-d3eadac65edc" />
					</svg>
				</div>
				<div className="mx-auto max-w-7xl px-6 py-32 sm:px-8 sm:pt-40">
					<div className="mx-auto max-w-prose text-base lg:grid lg:max-w-none lg:grid-cols-2 lg:gap-8">
						<div>
							<h2 className="mt-2 text-3xl font-extrabold leading-8 tracking-tight text-neutral-50 sm:text-4xl">
								{person?.name}
							</h2>
							<h3 className="text-base font-semibold uppercase tracking-wide text-[#f9c04d]">
								{person?.role}
							</h3>
						</div>
					</div>
					<div className="mt-8 lg:grid lg:grid-cols-2 lg:gap-12">
						<div className="relative lg:col-start-2 lg:row-start-1">
							<div className="relative mx-auto max-w-prose text-base lg:max-w-none">
								<figure>
									<div className="aspect-w-12 aspect-h-7 lg:aspect-none">
										<FacultyPhoto
											name={person?.name ?? 'Faculty'}
											imageUrl={person?.imageUrl}
											className="w-full object-center"
										/>
									</div>
								</figure>
							</div>
						</div>
						<div className="mt-8 lg:mt-0">
							<div className="prose prose-red mx-auto space-y-4 text-neutral-200 lg:col-start-1 lg:row-start-1 lg:max-w-none">
								{person?.bio.map((b) => <p key={b.paragraph}>{b.paragraph}</p>)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</main>
	)
}
